import { Injectable } from '@angular/core';
import { ActiveState, EntityState, StoreConfig } from '@datorama/akita';
import { Y42EntityStore } from '@y42/state';
import { DatasourceColumnBackendModel } from '../models';

export interface TableColumnsState
  extends EntityState<DatasourceColumnBackendModel, DatasourceColumnBackendModel['field_name']>,
    ActiveState {}

const initialState: TableColumnsState = {
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'columns', idKey: 'field_name' })
export class TableColumnsStore extends Y42EntityStore<TableColumnsState> {
  constructor() {
    super(initialState);
  }
}
